import { Outlet } from 'react-router-dom';

import CampaignsProvider from '@/src/modules/CampaignsModule/contexts/CampaignsContext';

const CampaignsLayout = () => {
  return (
    <CampaignsProvider>
      <Outlet />
    </CampaignsProvider>
  );
};

export default CampaignsLayout;
